<template>
  <el-dialog
    :title="modalTitle"
    :visible.sync="showModal"
    width="1000px"
    custom-class="modal_main_wrap"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :before-close="bindCloseModal"
  >
    <div class="modal_filter_wrap">
      <el-form :inline="true" label-width="100px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item class="full_width" label="门店名称：">
              <el-input v-model.trim="storeName" placeholder="请输入门店名称" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="bindSetSearch">查询</el-button>
            <el-button @click="bindSetReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="modal_table_wrap">
      <el-table
        ref="table"
        :data="tableData"
        border
        max-height="500"
        :row-key="getRowKeys"
        :row-class-name="handleRowClass"
        @row-click="bindSetRadio"
        @selection-change="bindGetCheck"
      >
        <el-table-column v-if="mark !== 'radio'" type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column prop="storeName" align="center" label="门店名称" show-overflow-tooltip />
      </el-table>
    </div>
    <div class="modal_foot_wrap">
      <el-pagination
        :current-page="pageNum"
        :page-sizes="[10, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="total"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
      />
      <div>
        <el-button type="default" @click="bindCloseModal">取消</el-button>
        <el-button type="primary" @click="bindSureModal">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import $api from '@/api'
export default {
  name: 'StoreModal',
  props: {
    showModal: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    modalTitle: {
      type: String,
      default: () => {
        return ''
      }
    },
    drugStore: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    mark: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      storeName: '',
      radioStore: {},
      tableData: [],
      checkStoreArr: []
    }
  },
  watch: {
    showModal: {
      handler(newVal) {
        if (newVal) {
          const { list, mark, drugStore } = this
          this.checkStoreArr = list
          this.$nextTick(() => {
            if (mark === 'radio') {
              this.radioStore = JSON.parse(JSON.stringify(drugStore))
              this.tableData.forEach(item => {
                this.$refs.table.setCurrentRow(item, true)
              })
            } else {
              this.checkStoreArr.forEach(item => {
                this.$refs.table.toggleRowSelection(item, true)
                this.handleClearFilter()
              })
            }
          })
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getRechargeStore()
  },
  methods: {

    // 获取门店列表
    async getRechargeStore() {
      const { pageNum, pageSize, storeName, mark } = this
      const params = { pageNum, pageSize, query: { storeName }}

      try {
        const { data } = await $api.QUICKPRESCRIBE.getRechargeStore(params)
        this.total = data.total
        this.tableData = data.content || []

        if (!mark && this.$refs.table) {
          this.checkStoreArr = this.$refs.table.selection
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 搜索门店按钮
    bindSetSearch() {
      this.pageNum = 1
      this.getRechargeStore()
    },

    // 重置门店搜索
    bindSetReset() {
      this.handleClearFilter()
    },

    // 获取选中的药店
    bindGetCheck(event) {
      this.checkStoreArr = event
    },

    // 单选操作-获取选择的药品
    bindSetRadio(row) {
      const { mark, radioStore } = this
      if (mark !== 'radio') return
      if (radioStore.storeId && radioStore.storeId === row.id) {
        this.radioStore = {
          storeId: '',
          storeName: ''
        }
      } else {
        this.radioStore.storeId = row.id
        this.radioStore.storeName = row.storeName
      }
    },

    // 单选操作—处理选中行显示
    handleRowClass({ row }) {
      const { mark, radioStore } = this
      if (mark !== 'radio') return ''
      if (radioStore.storeId === row.id) {
        return 'tabRadioClass'
      }
    },

    // 删除选中的药店
    bindDeleteStore(index, item) {
      this.checkStoreArr.splice(index, 1)
      this.$refs.table.toggleRowSelection(item, false)
    },

    // 确定按钮
    bindSureModal() {
      const { mark, radioStore, checkStoreArr } = this
      // 多选判断
      if (!mark === !checkStoreArr.length) {
        this.handleSetError('请至少选择一个药店')
        return
      }

      // 单选判断
      if (mark === 'radio' && !radioStore.storeId) {
        this.handleSetError('请选择药店')
        return
      }

      if (mark === 'radio') {
        this.$emit('change', radioStore)
      } else {
        this.$emit('change', checkStoreArr)
      }

      this.bindCloseModal()
    },

    // 关闭弹窗
    bindCloseModal() {
      this.$emit('update:showModal', false)
    },

    // 选中药店的key值
    getRowKeys(row) {
      return row.id
    },

    // 改变页面显示长度
    onSizeChange(e) {
      this.pageSize = e
      this.pageNum = 1
      this.getRechargeStore()
    },

    // 改变页码
    onCurrentChange(e) {
      this.pageNum = e
      this.getRechargeStore()
    },

    // 清空过滤条件,进行查询
    handleClearFilter() {
      this.pageNum = 1
      this.storeName = ''
      this.getRechargeStore()
    },

    // 操作提示
    handleSetError(message, type = 'error') {
      this.$message({ type, message })
    }
  }
}
</script>

<style lang='less' scoped>
/deep/.el-dialog__body {
  padding: 10px 20px;

  .el-form-item__label {
    padding: 0;
  }

  .el-table__row {
    cursor: pointer;
  }

  .tabRadioClass {
    background: #43aab7;
    color: #fff;

    &:hover {
      td {
        background: #43aab7 !important;
      }
    }
  }
}

.modal_main_wrap {
  .modal_check_wrap {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;

    .store_item_wrap {
      position: relative;
      margin-right: 14px;
      margin-bottom: 8px;
      box-sizing: border-box;
      padding: 4px 10px;
      border: 1px solid #6092f5;
      border-radius: 18px;

      .store_item {
        font-size: 12px;
        color: #487dd6;
      }

      .icon_store {
        position: absolute;
        top: -4px;
        right: -4px;
        width: 12px;
        height: 12px;
      }
    }
  }

  .modal_foot_wrap {
    height: 40px;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/storeModal/storeModal.vue